export type Language = 'fr' | 'ar' | 'en';

export const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      about: 'À Propos',
      services: 'Services',
      contact: 'Contact',
    },
    hero: {
      title: 'Bienvenue chez Bloom clinic',
      subtitle: 'Des soins du visage et du corps pensés pour chaque femme',
      cta: 'Réserver ma consultation',
    },
    booking: {
      title: 'Choisissez votre rendez-vous',
      subtitle: 'Sélectionnez une date et une heure',
      selectedDate: 'Date sélectionnée',
      availableTimes: 'Horaires disponibles',
      selectedDateDisplay: 'Rendez-vous le',
      selectDateFirst: 'Sélectionnez d\'abord une date',
      selectedDateTime: 'Rendez-vous confirmé',
      chooseDate: 'Choisissez votre date',
      chooseTime: 'Choisissez votre heure',
      selectedTime: 'Heure sélectionnée',
      next: 'Suivant',
      back: 'Retour',
      confirm: 'Confirmer',
    },
    appointment: {
      title: 'Prendre Rendez-vous',
      subtitle: 'Complétez vos informations pour confirmer votre rendez-vous',
      fullName: 'Nom Complet',
      email: 'Adresse Email',
      phone: 'Numéro de Téléphone',
      service: 'Service',
      city: 'Ville',
      date: 'Date',
      time: 'Heure',
      submit: 'Réserver ma consultation',
      submitting: 'Confirmation...',
      successTitle: 'Rendez-vous Confirmé !',
      successMessage: 'Nous vous enverrons une confirmation par email',
      validationError: 'Veuillez corriger les erreurs',
      error: 'Une erreur est survenue',
      dateAutoFill: 'Sélectionnez une date dans le calendrier ci-dessus',
      timeAutoFill: 'Sélectionnez une heure dans le calendrier ci-dessus',
      thankYouTitle: 'Merci !',
      thankYouMessage: 'Votre rendez-vous a été confirmé avec succès',
      thankYouSubMessage: 'Nous vous enverrons bientôt une confirmation par email',
      redirectMessage: 'Vous serez redirigé vers la page d\'accueil dans quelques secondes...',
      services: {
        bodycare: 'Soins du corps',
        weightloss: 'Amincissement',
        packminceurcomplet: 'Traitement minceur',
        packhydrafacialcarbonpeelteeth: 'Pack Hydrafacial & Carbon Peel + Blanchiment Dentaire',
        epilation: 'Épilation laser',
        skincare: 'Soins du visage',
        teeth: 'Blanchiment dentaire',
      },
      cities: {
        casablanca: 'Casablanca',
        rabat: 'Rabat',
      },
    },
    videos: {
      title: 'Nos Services en Vidéo',
      subtitle: 'Découvrez nos prestations et témoignages',
      women: [
        {
          title: 'la Pressothérapie',
          description: 'Soin de pressothérapie pour drainage et récupération.',
          src: '/videos/la Pressothérapie.mp4',
        },
        {
          title: 'Traitement Anti-Cellulite',
          description: 'Traitement ciblé pour lisser et tonifier la peau.',
          src: '/videos/Traitement Anti-Cellulite.mp4',
        },
      ],
    },
    footer: {
      addresses: 'Adresses',
      hours: 'Horaires',
      contact: 'Contact',
      followUs: 'Suivez-nous',
      casablanca: 'Casablanca',
      rabat: 'Rabat',
      workingHours: 'Lundi - Vendredi: 09:00 - 18:00',
      saturday: 'Samedi: 10:00 - 17:00',
      closed: 'Dimanche: Fermé',
    },
    validation: {
      required: 'Ce champ est requis',
      minLength: 'Au moins 3 caractères',
      invalidEmail: 'Email invalide',
      invalidPhone: 'Téléphone invalide',
    },
  },
  ar: {
    nav: {
      home: 'الرئيسية',
      about: 'حول',
      services: 'الخدمات',
      contact: 'اتصل',
    },
    hero: {
      title: 'أهلا بك في Bloom clinic',
      subtitle: 'عناية بالوجه والجسم مصممة لكل امرأة',
      cta: 'احجز موعد',
    },
    booking: {
      title: 'اختر موعدك',
      subtitle: 'حدد التاريخ والوقت',
      selectedDate: 'التاريخ المختار',
      availableTimes: 'الأوقات المتاحة',
      selectedDateDisplay: 'موعدك في',
      selectDateFirst: 'حدد التاريخ أولاً',
      selectedDateTime: 'تم تأكيد الموعد',
      chooseDate: 'اختر تاريخك',
      chooseTime: 'اختر وقتك',
      selectedTime: 'الوقت المختار',
      next: 'التالي',
      back: 'رجوع',
      confirm: 'تأكيد',
    },
    appointment: {
      title: 'احجز موعد',
      subtitle: 'أكمل معلوماتك لتأكيد موعدك',
      fullName: 'الاسم الكامل',
      email: 'عنوان البريد الإلكتروني',
      phone: 'رقم الهاتف',
      service: 'الخدمة',
      city: 'المدينة',
      date: 'التاريخ',
      time: 'الوقت',
      submit: 'تأكيد الموعد',
      submitting: 'جاري التأكيد...',
      successTitle: 'تم تأكيد الموعد !',
      successMessage: 'سنرسل لك تأكيداً عبر البريد الإلكتروني',
      validationError: 'يرجى تصحيح الأخطاء',
      error: 'حدث خطأ ما',
      dateAutoFill: 'حدد التاريخ من التقويم أعلاه',
      timeAutoFill: 'حدد الوقت من التقويم أعلاه',
      thankYouTitle: 'شكراً لك !',
      thankYouMessage: 'تم تأكيد موعدك بنجاح',
      thankYouSubMessage: 'سنرسل لك قريباً تأكيداً عبر البريد الإلكتروني',
      redirectMessage: 'سيتم إعادة توجيهك إلى الصفحة الرئيسية في بضع ثوان...',
      services: {
        bodycare: 'العناية بالجسم',
        weightloss: 'فقدان الوزن',
        packminceurcomplet: 'باك التنحيف الكامل',
        packhydrafacialcarbonpeelteeth: 'باقة هيدرافيشل وكربون بيل مع تبييض الأسنان',
        epilation: 'إزالة الشعر الدائمة',
        skincare: 'العناية بالبشرة',
        teeth: 'تبييض الأسنان',
      },
      cities: {
        casablanca: 'الدار البيضاء',
        rabat: 'الرباط',
      },
    },
    videos: {
      title: 'خدماتنا بالفيديو',
      subtitle: 'اكتشف خدماتنا وشهادات عملائنا',
      women: [
        {
          title: 'معالجة الضغط',
          description: 'علاج معالجة الضغط للتصريف والتعافي.',
          src: '/videos/la Pressothérapie.mp4',
        },
        {
          title: 'علاج مضاد للسيلولايت',
          description: 'علاج موجه لتنعيم وشد البشرة.',
          src: '/videos/Traitement Anti-Cellulite.mp4',
        },
      ],
    },
    footer: {
      addresses: 'العناوين',
      hours: 'الساعات',
      contact: 'اتصل',
      followUs: 'تابعنا',
      casablanca: 'الدار البيضاء',
      rabat: 'الرباط',
      workingHours: 'الاثنين - الجمعة: 09:00 - 18:00',
      saturday: 'السبت: 10:00 - 17:00',
      closed: 'الأحد: مغلق',
    },
    validation: {
      required: 'هذا الحقل مطلوب',
      minLength: 'على الأقل 3 أحرف',
      invalidEmail: 'بريد إلكتروني غير صحيح',
      invalidPhone: 'رقم هاتف غير صحيح',
    },
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      contact: 'Contact',
    },
    hero: {
      title: 'Welcome to Bloom clinic',
      subtitle: 'Face and body care designed for every woman',
      cta: 'Book an Appointment',
    },
     booking: {
      title: 'Choose your appointment',
      subtitle: 'Select a date and time',
      selectedDate: 'Selected date',
      availableTimes: 'Available times',
      selectedDateDisplay: 'Your appointment on',
      selectDateFirst: 'Select a date first',
      selectedDateTime: 'Appointment confirmed',
      chooseDate: 'Choose your date',
      chooseTime: 'Choose your time',
      selectedTime: 'Selected time',
      next: 'Next',
      back: 'Back',
      confirm: 'Confirm',
    },
    appointment: {
      title: 'Book an Appointment',
      subtitle: 'Complete your information to confirm your appointment',
      fullName: 'Full Name',
      email: 'Email Address',
      phone: 'Phone Number',
      service: 'Service',
      city: 'City',
      date: 'Date',
      time: 'Time',
      submit: 'Confirm Appointment',
      submitting: 'Confirming...',
      successTitle: 'Appointment Confirmed!',
      successMessage: 'We will send you a confirmation email',
      validationError: 'Please correct the errors',
      error: 'An error occurred',
      dateAutoFill: 'Select a date from the calendar above',
      timeAutoFill: 'Select a time from the calendar above',
      thankYouTitle: 'Thank You!',
      thankYouMessage: 'Your appointment has been successfully confirmed',
      thankYouSubMessage: 'We will send you a confirmation email shortly',
      redirectMessage: 'You will be redirected to the home page in a few seconds...',
      services: {
        bodycare: 'Body Care',
        weightloss: 'Weight Loss',
        packminceurcomplet: 'Complete Slimming Pack',
        packhydrafacialcarbonpeelteeth: 'HydraFacial & Carbon Peel + Teeth Whitening Package',
        epilation: 'Permanent Hair Removal',
        skincare: 'Skincare',
        teeth: 'Teeth Whitening',
      },
      cities: {
        casablanca: 'Casablanca',
        rabat: 'Rabat',
      },
    },
    videos: {
      title: 'Our Services in Video',
      subtitle: 'Discover our services and client testimonials',
      women: [
        {
          title: 'Pressotherapy',
          description: 'Pressotherapy treatment for drainage and recovery.',
          src: '/videos/la Pressothérapie.mp4',
        },
        {
          title: 'Anti-Cellulite Treatment',
          description: 'Targeted treatment to smooth and tone skin.',
          src: '/videos/Traitement Anti-Cellulite.mp4',
        },
      ],
    },
    footer: {
      addresses: 'Addresses',
      hours: 'Hours',
      contact: 'Contact',
      followUs: 'Follow Us',
      casablanca: 'Casablanca',
      rabat: 'Rabat',
      workingHours: 'Monday - Friday: 09:00 - 18:00',
      saturday: 'Saturday: 10:00 - 17:00',
      closed: 'Sunday: Closed',
    },
    validation: {
      required: 'This field is required',
      minLength: 'At least 3 characters',
      invalidEmail: 'Invalid email',
      invalidPhone: 'Invalid phone number',
    },
  },
};

export function getTranslation(language: Language, key: string): string {
  const keys = key.split('.');
  let value: any = translations[language];
  
  for (const k of keys) {
    value = value?.[k];
  }
  
  return value || key;
}
